import tingle from 'tingle.js'

window.submitQuestion = () => {
  const form = document.querySelector("form[name='ask_us']");

  if(!document.getElementById('ask_us_fullName').checkValidity()) {
    document.getElementById('ask_us_fullName').classList.add('invalid');
    return false;
  }
  if(!document.getElementById('ask_us_email').checkValidity()) {
    document.getElementById('ask_us_email').classList.add('invalid');
    return false;
  }
  if(!document.getElementById('ask_us_question').checkValidity()) {
    document.getElementById('ask_us_question').classList.add('invalid');
    return false;
  }

  var modal = new tingle.modal({
    footer: true,
    stickyFooter: false,
    closeMethods: ['overlay', 'button', 'escape'],
    closeLabel: "Close",
  });
  modal.setContent('<div class="text-center"><i class="fas fa-spinner fa-spin"></i></div>');
  const url = form.getAttribute('async-action');
  const http = new XMLHttpRequest();
  http.open("POST", url);
  http.send(new FormData(form));
  modal.open();
  http.onload = () => {
    var result = JSON.parse(http.responseText);
    modal.setContent(result['response']);
    modal.addFooterBtn('OK', 'btn outline', function() {
      modal.close();
    });
  };
  return false;
};